<template>
  <div class="userManage">
    <div class="userManageBox">
      <el-row>
        <el-col :span="20">数据筛选</el-col>
        <el-col :span="4">
          <el-button type="success" round icon="el-icon-check" size="small" @click="searchData()">确 认</el-button>
          <el-button type="info" round icon="el-icon-refresh-left" size="small" @click="clearFilter()">重 置</el-button>
        </el-col>
      </el-row>
      <el-row :gutter="10" class="filter">
        <el-col :span="6">
          <span class="label">用户</span>
          <el-input
            v-model="filterData.searchTerm"
            placeholder="请输入用户姓名"
            style="width: auto"
          ></el-input>
        </el-col>
        <!--        <el-col :span="6">-->
        <!--          <span class="label">区域</span>-->
        <!--          <el-select-->
        <!--            class="area"-->
        <!--            v-model="filterData.regionNo"-->
        <!--            placeholder="请选择"-->
        <!--            multiple-->
        <!--            @change="getOptions"-->
        <!--          >-->
        <!--            <el-option-->
        <!--              v-for="item in areaList"-->
        <!--              :key="item.no"-->
        <!--              :label="item.name"-->
        <!--              :value="item.no">-->
        <!--            </el-option>-->
        <!--          </el-select>-->
        <!--        </el-col>-->
        <!--        <el-col :span="6">-->
        <!--          <span class="label">客户</span>-->
        <!--          <el-select-->
        <!--            class="area"-->
        <!--            v-model="filterData.resellerNo"-->
        <!--            multiple-->
        <!--            placeholder="请选择"-->
        <!--            @change="getOptions"-->
        <!--          >-->
        <!--            <el-option-->
        <!--              v-for="item in customerList"-->
        <!--              :key="item.no"-->
        <!--              :label="item.name"-->
        <!--              :value="item.no">-->
        <!--            </el-option>-->
        <!--          </el-select>-->
        <!--        </el-col>-->
        <el-col :span="6">
          <span class="label">角色</span>
          <el-select
            class="area"
            v-model="filterData.roleCode"
            multiple
            placeholder="请选择"
          >
            <el-option
              v-for="item in roleList"
              :key="item.code"
              :label="item.name"
              :value="item.code">
            </el-option>
          </el-select>
        </el-col>

        <el-col :span="6">
          <span class="label">状态</span>
          <el-select
            class="area"
            v-model="filterData.status"
            placeholder="请选择"
          >
            <el-option
              v-for="item in statusList"
              :key="item"
              :label="item"
              :value="item">
            </el-option>
          </el-select>
        </el-col>
      </el-row>
      <el-divider></el-divider>

      <el-row>
        <el-col :span="22">数据列表</el-col>
        <el-col :span="2">
          <input type="file" ref="importFile" @change="importExcel"/>
          <el-button
            plain
            round
            icon="el-icon-plus"
            size="small"
            style="color: #67C23A"
            @click="$refs.importFile.click()"
          >
            导 入
          </el-button>
        </el-col>
      </el-row>

      <el-table
        style="width: 100%; margin-top: 20px"
        fit
        stripe
        :data="tableData"
        v-loading="tableLoading"
        border
      >
        <el-table-column
          sortable
          prop="name"
          label="用户名称"
          width="200"
        ></el-table-column>
        <el-table-column
          sortable
          prop="cellphone"
          label="手机号"
          width="auto"
        ></el-table-column>
        <el-table-column
          sortable
          prop="roleName"
          label="角色"
          width="auto"
        ></el-table-column>
        <el-table-column
          sortable
          :sort-method="statusSort"
          prop="status"
          label="用户状态"
          width="auto"
        ></el-table-column>
        <!--        <el-table-column-->
        <!--          prop="regionName"-->
        <!--          label="区域"-->
        <!--          width="150"-->
        <!--        >-->
        <!--        </el-table-column>-->
        <!--        <el-table-column-->
        <!--          prop="resellerName"-->
        <!--          label="客户"-->
        <!--          width="150"-->
        <!--        >-->
        <!--        </el-table-column>-->
        <!--        <el-table-column-->
        <!--          prop="level"-->
        <!--          label="等级"-->
        <!--          width="150"-->
        <!--        >-->
        <!--        </el-table-column>-->
        <el-table-column label="操作" width="150">
          <template slot-scope="scope">
            <el-button type="text" style="color: #606266" icon="el-icon-edit" size="mini" @click="openEdit(scope.row.id)"
            >编辑
            </el-button>
            <el-button type="text" style="color: #606266" icon="el-icon-delete" size="mini" @click="onDelete(scope.row.id)"
            >删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <footer>
        <el-pagination
          background
          layout="prev, pager, next"
          @current-change="currentChange"
          :current-page="tableConfig.current"
          :total="total"
        ></el-pagination>
      </footer>
    </div>
  </div>
</template>
<script>
import md5 from "md5";
import _ from "lodash";

export default {
  name: "UserManage",
  data() {
    return {
      filterData: {},
      initialFilterData: {
        searchTerm: '',
        regionNo: [],
        resellerNo: [],
        roleCode: [],
        status: ''
      },
      areaList: [],
      customerList: [],
      roleList: [],
      statusList: ['正常', '锁定'],
      tableData: null, // 列表
      total: 10, // 总数量
      tableConfig: {
        "size": 10, // 每页数量
        "current": 1, // 当前页码
        "orders": [
          {
            "asc": true,
            "column": ""
          }
        ],
      },
      tableLoading: false
    }
  },
  mounted() {
    this.clearFilter();
    this.getData();
    this.getOptions();
    this.getRoleList();
  },
  methods: {
    searchData() {
      this.tableConfig.current = 1;
      this.getData();
    },
    async getData() {
      // 获取列表
      this.tableLoading = true;
      const params = _.assign(this.tableConfig, this.filterData)
      let res = await axios.post("oprReqUrl+account/list", params);
      if (res.data.code === 200) {
        this.tableData = res.data.data.list
        this.total = res.data.data.total
        console.log(this.tableData)
        //this.tableData = res.data.doorList.list || [];
        //this.total = res.data.doorList.total;
      }
      this.tableLoading = false;
    },
    currentChange(index) {
      // 分页
      this.tableConfig.current = index;
      this.getData();
    },
    openEdit(id) {
      console.log('id', id);
      this.$router.push({path: '/pages/userManageEdit', query: {id}});
    },
    openCreate() {
      this.$router.push({path: '/pages/userManageEdit'});
    },
    clearFilter() {
      this.filterData = _.cloneDeep(this.initialFilterData);
    },
    async getOptions() {
      const params = {
          region: this.filterData.regionNo,
          reseller: this.filterData.resellerNo
        },
        res = await axios.post(oprReqUrl+"door/linkage", params);
      if (res.data.code === 200) {
        const dataList = res.data.data;
        this.areaList = dataList.region || [];
        this.customerList = dataList.reseller || [];
      }
    },
    async getRoleList() {
      let res = await axios.post(oprReqUrl+"account/rolelist");
      if (res.data.code === 200) {
        const dataList = res.data.data;
        this.roleList = dataList
      }
    },
    async onDelete(id) {
      this.$confirm("确认删除吗？", "提示", {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(async () => {
          let res = await axios.delete("account/" + id);
          res = res.data
          if (res.code === 200) {
            await this.getData()
            this.$message.success(res.message)
          } else {
            this.$message.warning(res.message)
          }
        })
        .catch(_ => {
        })
    },
    async importExcel({target}) {
      let formData = new FormData();
      formData.append("file", target.files[0]);
      let res = await axios.post(oprReqUrl+"account/batchImportAccount", formData);
      if (res.data.code === 200) this.$message.success("导入成功！");
      else this.$message.error("导入失败！");
    },
    statusSort(a, b) {
      if (a.status === null) {
        return -1
      } else if (b.status === null) {
        return 1
      } else if (a.status === 'Lock') {
        return -1
      } else if (b.status === 'Lock') {
        return 1
      }
      return 0
    }
  }
};
</script>
<style lang="sass" scoped>
.userManage
  input[type=file]
    display: none
  min-width: 1050px

  .userManageBox
    padding: 20px

    .title
      color: #6F6F6F
      font-size: 26px
      font-weight: 600
      letter-spacing: 2px
      text-align: center
      margin-bottom: 30px

    .filter
      margin-top: 30px

    .label
      font-size: 14px
      color: #606266

    .table-container
      margin-top: 20px

    footer
      padding-top: 20px
      text-align: right
</style>



// WEBPACK FOOTER //
// src/opr/pages/views/userManage.vue